export class ActivationHelpController {
    /* @ngInject */
    constructor($window, $cookies, $state,  $stateParams, helpButtonService) {
        this.$window = $window;
        this.$cookies = $cookies;
        this.state = $stateParams.state;
        this.helpButtonLocation = null;
        this.locale = this.$cookies.get('NG_TRANSLATE_LANG_KEY');

        helpButtonService.getOrCreateHelpLocation(this.locale)
            .then(response => {
                this.helpButtonLocation = response;
            });
    }

    openHelpGuide() {
        var location = this.helpButtonLocation;
        var locale = this.$cookies.get('NG_TRANSLATE_LANG_KEY');

        if(locale === '\"da\"'){
            location = location.replace('{{LOCALE}}', "DK");
        } else {
            location = location.replace('{{LOCALE}}', "ENG");
        }
        this.$window.open(location);
    }
}